var _style, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56.3 33.3",
    style: {
      enableBackground: "new 0 0 56.3 33.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.5,6.2C11.4,6.2,9,8.6,9,11.6s2.4,5.4,5.5,5.4s5.5-2.4,5.5-5.4C20,8.7,17.6,6.2,14.5,6.2z M7,11.6 c0-4.1,3.4-7.4,7.5-7.4S22,7.5,22,11.6S18.6,19,14.5,19S7,15.7,7,11.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.5,22.2c-1.9,0-3.5,1.6-3.5,3.5s1.6,3.5,3.5,3.5h14c1.9,0,3.5-1.5,3.6-3.5c0-1.9-1.6-3.5-3.5-3.5 C21.6,22.2,7.5,22.2,7.5,22.2z M2,25.7c0-3.1,2.4-5.5,5.5-5.5h14.1c3.1,0,5.5,2.4,5.5,5.5l0,0c-0.1,3-2.5,5.5-5.6,5.5h-14 C4.4,31.2,2,28.8,2,25.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.1,5.8c-3.1,0-5.5,2.4-5.5,5.4s2.4,5.4,5.5,5.4s5.5-2.4,5.5-5.4S44.1,5.8,41.1,5.8z M33.6,11.2 c0-4.1,3.4-7.4,7.5-7.4s7.5,3.3,7.5,7.4s-3.4,7.4-7.5,7.4C36.9,18.6,33.6,15.3,33.6,11.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.1,21.8c-1.9,0-3.5,1.6-3.5,3.5s1.6,3.5,3.5,3.5h14c1.9,0,3.5-1.5,3.6-3.5c0-1.9-1.6-3.5-3.5-3.5H34.1z  M28.6,25.3c0-3.1,2.4-5.5,5.5-5.5h14.1c3.1,0,5.5,2.4,5.5,5.5l0,0c-0.1,3-2.5,5.5-5.6,5.5h-14C31,30.8,28.6,28.4,28.6,25.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount2);
export default __webpack_public_path__ + "static/media/account2.dab78eb820dfb4c45f38b28a608bb99e.svg";
export { ForwardRef as ReactComponent };